// @flow

import {EventRules, Language, User, TabDataFlags, EventRuleChange} from '@/types'

import React, {Component} from 'react'
import {connect} from 'react-redux'
import {keys, mergeAll, pipe, reject, values} from 'ramda'
import {appSelectors, portfoliosActions, portfoliosSelectors, appActions} from '@/store'

import CountrySelect from '@/controls/country-select'
import Section from '@/elements/section'

import GlobalRules from './rules/global-rules'
import Rules from './rules/index'
import {isAnyTabDataLoaded, isPermissionEnabled, handleGlobalAll} from '@/views/util'

type Props = {
  rules: EventRules,
  rulesChanged: boolean,
  saveRuleChanges: () => void,
  l: Language,
  user: User,
  tabDataFlags: TabDataFlags,
  fetchSettingsTabInitialData: () => void,
  changeActivePortfolio: (number) => void,
  fetchCommonTabsData: () => void,
  isLoading: boolean,
  isActivePortfolioShared: boolean,
  activePortfolioPermissions: string,
  fetchPortfolioCountries: () => void,
  changeEventRule: (country: string, groupId: number, EventRuleChange) => void,
  activePortfolioId: number,

}

type State = {
  shownCountry: string,
}

const checkAndFetchData = (props) => {
  // call apis to fetch this tab data
  if (!props.tabDataFlags.isSettingsDataLoaded && !props.isLoading) {
    // fetch common tab data if no tab is loaded yet
    if (!isAnyTabDataLoaded(props.tabDataFlags)) {
      props.fetchCommonTabsData()
    }
    // fetch portfolio countries if portfolio tab is not loaded yet
    if (!props.tabDataFlags.isPortfoliosDataLoaded) {
      props.fetchPortfolioCountries()
    }
    // fetch this tab data
    props.fetchSettingsTabInitialData()
    // change to Default portfolio when the previous portfolio is All portfolios
    if (props.activePortfolioId === 0) {
      props.changeActivePortfolio(props.activePortfolioId)
    }
  }
}

const renderSaveChangesButton = ({isActivePortfolioShared, activePortfolioPermissions, rulesChanged, saveRuleChanges, l}) =>
  (!isActivePortfolioShared || isPermissionEnabled(activePortfolioPermissions, 'Edit'))
    ? <button
      id='save_rules_button'
      className="btn btn-success pull-right header-button"
      disabled={!rulesChanged}
      onClick={saveRuleChanges}
    >
      {l('Save changes')}
    </button>
    : null
const getRuleValues = (rules, shownCountry) => values(rules[shownCountry])
let checkAll
export class RawSettingsPage extends Component<Props, State> {
  constructor (props: Props) {
    super(props)

    this.state = {
      shownCountry: props.user.countryCode,
    }
  }

  changeCountry = (selected: string) =>
    this.setState({shownCountry: selected})

  equalsRejectableCountries = (countryCode: string) => {
    return (countryCode === 'XX' || countryCode === 'ZZ')
  }

  availableCountries = pipe(
    keys,
    reject(this.equalsRejectableCountries),
  )
  checkGlobalAll = (rules: Array<EventRules>) => {
    checkAll = !handleGlobalAll(rules)
    return checkAll
  }
  handleChange = (rules: Array<EventRules>) => (e: any) => {
    let inActiveRulesPresent
    inActiveRulesPresent = handleGlobalAll(rules, checkAll ? 0 : 1,
      this.state.shownCountry, e, this.props.changeEventRule)
    return inActiveRulesPresent
  }
  render = () =>
    <div>
      <Section header={this.props.l('Notification rules')} className='rules-section'>
        {renderSaveChangesButton(this.props)}
        <Section header={this.props.l('Global')} className='global-rules'>
          <GlobalRules />
        </Section>
        <Section header={this.props.l('Country')}>
          <span className='country-for-rules'>
            <CountrySelect
              allOption={false}
              availableCountries={this.availableCountries(this.props.rules).sort()}
              selected={this.state.shownCountry}
              onChange={this.changeCountry}
            />
          </span>
          <span className='checkbox global-all-checkbox'>
            <label>
              <input type= "checkbox"
                checked={(this.checkGlobalAll(getRuleValues(this.props.rules, this.state.shownCountry)))}
                onChange={(e) => this.handleChange(getRuleValues(this.props.rules, this.state.shownCountry))(e)}>
              </input>
              <span> {this.props.l('All ' + this.state.shownCountry + ' Country Rules')} </span>
            </label>
          </span>
        </Section>
        <Section header={this.props.l('Rules')}>
          <Rules country={this.state.shownCountry}/>
        </Section>
      </Section>
    </div>

  componentDidMount = () => {
    checkAndFetchData(this.props)
  }

  componentWillReceiveProps = (nextProps: Props) => {
    checkAndFetchData(nextProps)
  }
}

const mapStateToProps = (state) => ({
  rules: portfoliosSelectors.getActivePortfolioRules(state),
  rulesChanged: state.ui.rulesChanged,
  l: appSelectors.getL(state),
  user: state.app.user,
  tabDataFlags: state.app.tabDataFlags,
  isLoading: state.app.showAppLoader,
  isActivePortfolioShared: portfoliosSelectors.isActivePortfolioShared(state),
  activePortfolioPermissions: portfoliosSelectors.getActivePortfolioPermissions(state),
  activePortfolioId: state.app.activePortfolioId,
})

export default connect(
  mapStateToProps,
  mergeAll([portfoliosActions, appActions])
)(RawSettingsPage)



// WEBPACK FOOTER //
// ./src/views/settings-page/index.js